import {s, lazy, filter} from './lang.js';
import {doc} from './documentation.js';

doc(
    "alt",
    {
        "arg1": "",
        "arg2": "",
        "argN": "",
    },
    "Alternates between the arguments with every trigger received by this function"
);

export const alt = (..._args) => {
    let counter = 0;
    return (... args) => {
        let [stepData, stepNumber, time] = args;
        if (stepData === undefined) {
            return filter(false);
        }

        let __args = _args;
        if (_args.length === 1) {
            let lazyEval = lazy(_args[0], ...args);
            if (Array.isArray(lazyEval)) {
                __args = lazyEval;
            }
        }
        let index = counter++ % __args.length;
        return lazy(s(__args[index]), ...args);
    };
};

export const r_alt = (..._args) => {
    let counter = 0;
    let lastAlt = undefined;
    let lastStepNumber = undefined;
    return (... args) => {
        let [stepData, stepNumber, time] = args;
        if (lastStepNumber === stepNumber) {
            return lastAlt;
        }
        lastStepNumber = stepNumber;
        if (stepData === undefined) {
            return lastAlt === undefined ?  _args[0] : lastAlt;
        }

        let __args = _args;
        if (_args.length === 1) {
            let lazyEval = lazy(_args[0], ...args);
            if (Array.isArray(lazyEval)) {
                __args = lazyEval;
            }
        }
        let index = counter++ % __args.length;
        lastAlt = lazy(s(__args[index]), ...args);
        return lastAlt;
    };
};


// every n triggers alternate outputs, across m-may outputs
doc(
    "altn",
    {
        "n": "How many triggers it takes to increment the output conditional",
        "arg1": "Output conditional",
        "arg2": "Output conditional",
        "argN": "Output conditional (will loop back to arg1 after this this)",
    },
    "Alternates between the arguments every n-many triggers received by this function"
);
export const altn = (n, ... outputs) => {
    let counter = 0;
    let outputNumber = 0;
    return (stepData, stepNumber, time, effect) => {
        let _n = typeof n === "number" ? n : n();
        if (++counter % _n === 0) {
            outputNumber++;
        }
        if (stepData === undefined) {
            return filter(false);
        }
        let output = outputs[outputNumber % outputs.length];
        return lazy(output, stepData, stepNumber, time, effect);
    };
};

export const t_altn = (n, ... outputs) => {
    let counter = 0;
    let outputNumber = 0;
    return (stepData, stepNumber, time, effect) => {
        let _n = typeof n === "number" ? n : n();
        if (++counter % _n === 0) {
            outputNumber++;
        }
        let output = outputs[outputNumber % outputs.length];
        return lazy(output, stepData, stepNumber, time, effect);
    };
};

export const t_alt = (..._args) => {
    let counter = 0;
    return (... args) => {
        let [stepData, stepNumber, time] = args;
        if (_args.length === 1) {
            let lazyEval = lazy(_args[0], ...args);
            if (Array.isArray(lazyEval)) {
                _args = lazyEval;
            }
        }
        let index = counter++ % _args.length;
        return lazy(s(_args[index]), ...args);
    };
};

doc(
    "every",
    {
        "n": "",
        "action": "",
    },
    "Trigger a given action every n-many triggers"
);

export const every = (n, action, elseAction) => {
    let counter = 0;
    return (... args) => {
        let _n = lazy(n, ...args);
        let stepData = args[0];
        if (stepData) {
            counter++;
            if (counter % _n === 0) {
                let ret = lazy(action, ...args);
                return ret;
            }
        }
        if (elseAction) {
            return lazy(elseAction, ...args);
        }
        return filter(true);
    };
};

